import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["open", "anchorEl", "SuggestionsComponent", "creatable", "toggleMenu", "disablePortal", "loading"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { Divider, Icon, IconButton, Paper, makeStyles, Box, Typography, Popper, RaiseColors, useTheme } from "components/mui";
import * as React from "react";
import Suggestion from "./DefaultAutoCompleteSuggestion";
import { OVERLAY_MENU_Z_INDEX } from "utils/constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      paper: {
        marginTop: "8px",
        maxHeight: "35vh",
        minWidth: 300,
        overflowY: "auto",
        position: "relative"
      },
      popper: {
        zIndex: OVERLAY_MENU_Z_INDEX
      }
    };
  });
};
var DefaultSuggestionsPopper = function DefaultSuggestionsPopper(_ref) {
  var open = _ref.open,
    anchorEl = _ref.anchorEl,
    _ref$SuggestionsCompo = _ref.SuggestionsComponent,
    SuggestionsComponent = _ref$SuggestionsCompo === void 0 ? DefaultSuggestions : _ref$SuggestionsCompo,
    creatable = _ref.creatable,
    toggleMenu = _ref.toggleMenu,
    _ref$disablePortal = _ref.disablePortal,
    disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
    loading = _ref.loading,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles()();
  var onCloseAndCreate = function onCloseAndCreate() {
    var inputValue = rest.inputValue,
      selectItem = rest.selectItem;
    selectItem({
      isNew: true,
      displayLabel: inputValue,
      label: inputValue,
      value: inputValue
    });
  };
  var onClose = creatable ? onCloseAndCreate : toggleMenu;
  return /*#__PURE__*/_jsx(Popper, {
    open: open,
    anchorEl: anchorEl,
    className: classes.popper,
    disablePortal: disablePortal,
    children: /*#__PURE__*/_jsxs(Paper, {
      className: classes.paper,
      square: true,
      style: {
        minWidth: anchorEl ? anchorEl.clientWidth : null
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_xsmall",
          weight: "semibold",
          color: RaiseColors.gray300,
          children: "Suggestions"
        }), loading && /*#__PURE__*/_jsx(Icon, {
          className: "fal fa-spin fa-spinner",
          color: RaiseColors.black,
          fontSize: 14
        }), /*#__PURE__*/_jsx(IconButton, {
          onClick: onClose,
          size: "small",
          children: /*#__PURE__*/_jsx(Icon, {
            className: "fal fa-times",
            fontSize: "small"
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(SuggestionsComponent, _objectSpread(_objectSpread({}, rest), {}, {
        classes: classes,
        creatable: creatable
      }))]
    })
  });
};
export default DefaultSuggestionsPopper;
function DefaultSuggestions(_ref2) {
  var _context2;
  var _ref2$suggestions = _ref2.suggestions,
    suggestions = _ref2$suggestions === void 0 ? [] : _ref2$suggestions,
    itemToString = _ref2.itemToString,
    getItemProps = _ref2.getItemProps,
    _ref2$creatable = _ref2.creatable,
    creatable = _ref2$creatable === void 0 ? false : _ref2$creatable,
    inputValue = _ref2.inputValue,
    getMenuProps = _ref2.getMenuProps;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getMenuProps()), {}, {
    children: [_mapInstanceProperty(suggestions).call(suggestions, function (suggestion, index) {
      var _context;
      return /*#__PURE__*/_jsx(Suggestion, _objectSpread({
        label: itemToString(suggestion)
      }, getItemProps({
        item: suggestion
      })), _concatInstanceProperty(_context = "".concat(index, "#")).call(_context, itemToString(suggestion)));
    }), creatable && !_findInstanceProperty(suggestions).call(suggestions, function (s) {
      var _itemToString;
      return inputValue && ((_itemToString = itemToString(s)) === null || _itemToString === void 0 ? void 0 : _itemToString.toLowerCase()) === inputValue.toLowerCase();
    }) && /*#__PURE__*/_jsx(Suggestion, _objectSpread({
      disabled: !creatable,
      label: _concatInstanceProperty(_context2 = "".concat(!suggestions.length ? "No results." : "", " ")).call(_context2, creatable ? "+ create ".concat(inputValue) : "")
    }, getItemProps({
      item: {
        isNew: true,
        displayLabel: inputValue,
        label: inputValue,
        value: inputValue
      }
    })))]
  }));
}